export default __webpack_public_path__ + "static/behance-ae5fdb3ba13e93229eaeffccf15daaff.png";